import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const DenZakhystuDitei2023 = () => {
  return (
    <Layout>
      <article>
        <h2>День захисту дітей</h2>
        <p className="top-spacing-big">
          Щороку в перший день літа відзначається Міжнародний день захисту дітей – найпрекрасніше свято радості та
          надії. Кожна дитина має повне право бути захищеною, розвиватися й навчатися для кращого майбутнього. І
          сьогодні – це не лише веселе свято для самих дітей, а й нагадування суспільству про необхідність захищати
          права малечі, прагнути, щоб усі діти росли щасливими і в майбутньому стали хорошими батьками і громадянами
          своєї мирної процвітаючої країни.
        </p>

        <div className="grid top-spacing-big">
          <div className="grid__item">
            <StaticImage
              className="image"
              layout="constrained"
              width={640}
              formats={['auto', 'webp', 'avif']}
              src="../../images/news/den-zakhystu-ditei-2023/den-zakhystu-ditei-2.jpg"
              alt="День захисту дітей"
            />
          </div>
        </div>

        <p className="top-spacing-big">
          До Міжнародного дня захисту дітей у нашому садочку організовано святкову розвагу для малят &quot;Наше
          дитинство-найкраща пора&quot;. Дитинство – це чудова пора надій і сподівань на прекрасне життя та здійснення
          мрій. Діти – це майбутнє нашої держави, яке формується в сьогоденні. Це не тільки веселе свято для самих
          дітей, це і нагадування суспільству про необхідність захищати права малечі, щоб усі діти росли щасливими,
          вчилися, займалися улюбленою справою і в майбутньому стали хорошими батьками і громадянами своєї країни
        </p>

        <p className="top-spacing-big">Приємного перегляду</p>

        <a href="https://fb.watch/lbaqHfUs21/" target="_blank" rel="noopener noreferrer" className="center-text">
          https://fb.watch/lbaqHfUs21/
        </a>
      </article>
    </Layout>
  );
};

export default DenZakhystuDitei2023;

export const Head = () => <SEO title="День захисту дітей" />;
